import { format } from "date-fns";
import { axiosApiInstance } from "../../pages/api/axios";
import { parseErrorsToArray } from "../../utils/parseErrors";

export const subscriptionsTabs = [
  { name: "Manage Plans", href: "/plans", current: false },
  {
    name: "Manage Subscriptions",
    href: "/subscriptions",
    current: true,
  },
  {
    name: "Manage Plan Groups",
    href: "/plan-groups",
    current: false,
  },
];

export const subscriptionAddPages = [
  {
    name: "Manage Subscriptions",
    href: "/subscriptions",
    current: false,
  },
  {
    name: "New Subscription",
    href: `/subscriptions/add`,
    current: true,
  },
];

export const planPages = [
  {
    name: "Manage Subscriptions",
    href: "/subscriptions",
    current: false,
  },
  {
    name: "Manage Plans",
    href: `/plans`,
    current: true,
  },
];

export const plantTabs = [
  { name: "Manage Plans", href: "/plans", current: true },
  {
    name: "Manage Subscriptions",
    href: "/subscriptions",
    current: false,
  },
];

export const discountDurations = {
  first_cycle: "First Cycle",
  all_cycles: "All Cycles",
  custom: "Custom",
};

export const recurrencesOptions = {
  null: "Forever",
  1: "1 cycle",
  3: "3 cycles",
  6: "6 cycles",
  custom: "Custom",
};

export const plansPages = [
  {
    name: "Subscriptions",
    href: "/subscriptions",
    current: false,
  },
  {
    name: "Manage Plans",
    href: `/plans`,
    current: true,
  },
];

export const plansTabs = [
  { name: "Manage Plans", href: "/plans", current: true },
  {
    name: "Manage Subscriptions",
    href: "/subscriptions",
    current: false,
  },
  {
    name: "Manage Plan Groups",
    href: "/subscription-embeds",
    current: false,
  },
];

export const createSubscription = (data) => {
  return axiosApiInstance
    .post(`/d/subscriptions/`, data)
    .then((res) => res.data.data);
};

export const getSubscription = (id) => {
  return axiosApiInstance.get(`/d/subscriptions/${id}/`).then((res) => {
    const subscription = res.data.data;
    return {
      ...res.data,
      data: {
        ...subscription,
        account: subscription.account.id,
        accountName: subscription.account.name,
        customer: subscription.customer.id,
        customerName: subscription.customer.name,
        plan: subscription.plan.id,
        planName: subscription.plan.name,
        start_date: format(new Date(subscription.start_date), "yyyy-MM-dd"),
        end_date:
          subscription.end_date &&
          format(new Date(subscription.end_date), "yyyy-MM-dd"),
        custom_fields: {
          ...subscription.custom_fields,
          discount_type: subscription?.custom_fields?.discount_amount
            ? "fixed_amount"
            : "percentage_discount",
        },
      },
    };
  });
};

export const getAccounts = () => {
  return axiosApiInstance.get(`/d/accounts/`, {
    params: {
      offset: 0,
      limit: 10,
    },
  });
};

export const getAccountCustomersWithSearch = (searchKeyword = undefined) => {
  const params = {
    offset: 0,
    limit: 10,
  };
  if (searchKeyword) {
    params.search = searchKeyword;
  }
  return axiosApiInstance
    .get(`/d/customers/`, {
      params,
    })
    .catch((err) => {
      return Promise.reject(parseErrorsToArray(err)?.[0]);
    });
};

export const getPlans = (params) => {
  return axiosApiInstance.get(`/d/subscriptions/plans/`, {
    params,
  });
};

export const getPlansWithSearch = (searchKeyword = undefined) => {
  const params = {
    offset: 0,
    limit: 10,
  };
  if (searchKeyword) {
    params.search = searchKeyword;
  }
  return axiosApiInstance
    .get(`/d/subscriptions/plans/`, {
      params,
    })
    .catch((err) => {
      return Promise.reject(parseErrorsToArray(err)?.[0]);
    });
};

export const createPlan = (data) => {
  return axiosApiInstance
    .post(`/d/subscriptions/plans/`, data)
    .then((res) => res.data.data);
};

export const getOrganizationCurrencies = (organizationId) => {
  return axiosApiInstance.get(
    `/d/organizations/${organizationId}/currencies/`,
    {
      params: { offset: 0, limit: 200 },
    }
  );
};

export const getPlan = (id) => {
  return axiosApiInstance
    .get(`/d/subscriptions/plans/${id}/`)
    .then((res) => res.data);
};
